module.exports = __webpack_public_path__ + "static/media/ipnos-component-2.360213bc.png";